import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "node",
  "use": "node-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"node\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.111 9H4.89A.885.885 0 004 9.875v5.25c0 .481.4.875.889.875H19.11a.885.885 0 00.889-.875v-5.25c0-.481-.4-.875-.889-.875zM7.556 14.25c-.978 0-1.778-.787-1.778-1.75 0-.962.8-1.75 1.778-1.75.977 0 1.777.788 1.777 1.75 0 .963-.8 1.75-1.777 1.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol